import type { MessageFunction } from 'vue-i18n';
import homepage from './pages/homepage/index';
import tech from './pages/tech/index';
import statistics from './pages/statistics/index';
import Info from './pages/info/index';
import system from './pages/system/index';
// 拉脱维亚
export default {
    license: {
        powered_by: 'SAIC Motor International {\'|\'} Visas tiesības aizsargātas',
    },
    auth: {
        login: 'Pieslēgties',
        username: 'Lietotājvārds',
        username_placeholder: 'Ievadiet lietotājvārdu',
        password: 'Parole',
        password_placeholder: 'Ievadiet paroli',
        code: 'Verifikācijas kods',
        code_placeholder: 'Ievadiet verifikācijas kodu',
        logout: 'Izlogoties',
        logout_success: 'Veiksmīgi izlogojāties',
        day: 'diena',
        password_expiration: 'Paroles derīguma termiņš beidzies – nepieciešams to nomainīt',
        expire: 'Līdz paroles derīguma beigām atlicis',
        conseils:
            'Jābūt lielajiem burtiem, mazajiem burtiem, cipariem un speciālajām zīmēm ({msg}). Paroles garumam jābūt no 8 līdz 16 zīmēm.',
        brand_Selection: 'Zīmolu atlase',
        unread_notices: 'Neizlasīti paziņojumi',
        new_cases: 'Jauni gadījumi',
        unanswered_cases: 'Neatbildēti gadījumi',
        overdue_cases: 'Nokavēti gadījumi',
    },
    button: {
        query: 'Vaicājums',
        editing_position: 'Rediģēt amatu',
        show_theme_editor: 'Rādīt / slēpt tēmas redaktoru',
        change_password: 'Mainīt paroli',
        old_password: 'Vecā parole',
        new_password: 'Jaunā parole',
        confirm_password: 'Apstiprināt paroli',
        button: 'Poga',
        about: 'Par',
        back: 'Atpakaļ',
        go: 'Labi',
        home: 'Sākumlapa',
        confirm: 'Apstiprināt',
        modify: 'Labot',
        edit: 'Rediģēt',
        new: 'Jauns',
        cancel: 'Atcelt',
        close: 'Aizvērt',
        search: 'Meklēt',
        reset: 'Atiestatīt',
        delete: 'Dzēst',
        add: 'Pievienot',
        collapse: 'Sakļaut',
        expand: 'Izvērst',
        download_template: 'Lejupielādēt veidni',
        batch_import: 'Masveida imports',
        import: 'Importēt',
        export: 'Eksportēt',
        export_fail: 'Imports neizdevās',
        detailed: 'Detalizēti',
        details: 'Sīkāka informācija',
        download: 'Lejupielādēt',
        toView: 'Skatīt',
        toViews: 'Skatīt attēlus',
        uploadAttachments: 'Augšupielādēt pielikumus',
        selectFile: 'Atlasiet failu',
        fillingInstructions: 'Aizpildīšanas instrukcijas',
        release: 'Publicēt',
        release_recall: 'Atsaukt publicēšanu',
        save: 'Saglabāt',
        send: 'Nosūtīt',
        tips: 'Padomi',
        send_back: 'Nosūtīt atpakaļ',
        examine: 'Pārbaudīt',
        void: 'Anulēt',
        more: 'Vairāk',
        refresh: 'Atjaunot',
        selects: 'Atlasiet',
        serial_number: 'Kārtas numurs',
        upload_progress: 'Augšupielādes progress',
        invalid: 'Nederīgs',
        daily_record: 'Dienas žurnāls',
        operation_type: 'Darbības veids',
        field_name: 'Lauka nosaukums',
        edit_role: 'Rediģēt lomu',
        user_role: 'Atlasiet lomu',
        assignment_role: 'Loma',
        post: 'Amats',
        sending: 'Notiek sūtīšana...',
        reset_password: 'Atjaunot paroli',
        display_or_not: 'Rādīt vai nerādīt',
        document: 'Dokuments',
        specificTemplates: 'Specifiskas veidnes',
        transferOrder: 'Pārskaitīt pasūtījumu',
        forwarding: 'Pārsūtīt',
        one_click_notification: 'Paziņojums ar vienu klikšķi',
        english_export: 'Eksports angļu valodā',
        oneclick_download: 'Lejupielāde ar vienu klikšķi',
        passwordmsga:
            'Jābūt lielajiem burtiem, mazajiem burtiem, cipariem un speciālajām zīmēm (@\\$!_~\\&*)',
        passwordmsgb: 'Paroles garumam jābūt no 8 līdz 16 zīmēm',
        passwordmsgc: 'Nedrīkst sakrist ar nevienu no iepriekšējām sešām parolēm',
        export_file_list: 'Eksportējamo failu saraksts',
        personal_center: 'Personīgais centrs',
        upload_list: 'Augšupielādēto failu saraksts',
        clear_completed: 'Notīrīt pabeigtos',
    },
    radio: {
        enabled: 'Iespējots',
        disabled: 'Atspējots',
        catalogue: 'Katalogs',
        individual: 'Individuāls',
        all: 'Visi',
        yes: 'Jā',
        no: 'Nē',
    },
    dropdown: {
        close_others: 'Aizvērt citus',
        close_right: 'Aizvērt pa labi',
        close_left: 'Aizvērt pa kreisi',
    },
    table: {
        action: 'Darbība',
        explain: 'Skaidrojums',
        fileName: 'Faila nosaukums',
        size: 'Izmērs (MB)',
        uploader: 'Augšupielādēja',
        uploadTime: 'Augšupielādes laiks',
        system: 'Sistēma',
        caption: 'Virsraksts',
        categorization: 'Kategorizācija',
        link: 'Saite',
        forwarding_time: 'Pārsūtīšanas laiks',
        forwarder: 'Pārsūtīja',
        send_to: 'Nosūtīt uz',
        mode: 'Režīms',
    },
    pagination: {
        pages: ({ named }: Parameters<MessageFunction>[0]) => `${named('number')}. lapa`,
        total: ({ named }: Parameters<MessageFunction>[0]) => `Kopā ${named('number')} ieraksti`,
        vinCount: ({ named }: Parameters<MessageFunction>[0]) =>
            `Kopā ${named('number')} transportlīdzekļi`,
    },
    confirm: {
        confirm_deletion: 'Vai apstiprināt dzēšanu?',
        confirm_void: 'Vai apstiprināt anulēšanu?',
        confirm_release: 'Vai apstiprināt publicēšanu?',
        ack: 'Apstiprināt',
        cancel: 'Atcelt',
        non_records: 'Atlasiet vismaz vienu ierakstu',
    },
    request: {
        failed_placeholder: 'Pieprasījums neizdevās – servera kļūda',
        success_placeholder: 'Pieprasījums veiksmīgs',
        auth: {
            login_success: 'Veiksmīgi pieslēdzāties',
        },
        error: {
            '404': 'Pieprasījuma ceļš nav atrasts',
            '403': 'Nepietiekamas tiesības',
        },
    },
    page: {
        global: {
            page_search: 'Meklēt lapā',
        },
        error: {
            not_found: 'Lapa nav atrasta',
            not_found_des: 'Šeit nekā nav',
            auth_failed: 'Nepietiekamas tiesības',
            auth_failed_des: 'Šī lapa ir aizliegta',
            file_format_error: 'Nepareizs faila formāts!',
            preview_failed: 'Priekšskatījums neizdevās! Fails ir bojāts!',
        },
        homepage: {
            homepage: homepage.homepage.lvLV,
        },
        system: {
            menu: system.menu.lvLV,
            dict: system.dict.lvLV,
            dept: system.dept.lvLV,
            role: system.role.lvLV,
            user: system.user.lvLV,
        },
        info: {
            announcement: Info.announcement.announcement.lvLV,
            document: Info.document.document.lvLV,
        },
        tech: {
            quality: {
                problemTracking: tech.quality.problemTracking.lvLV,
                recallActivity: tech.quality.recallActivity.lvLV,
                abnormalClaimTracking: tech.quality.abnormalClaimTracking.lvLV,
            },
            management: {
                inquiryOd: tech.management.inquiry.lvLV,
                permission: tech.management.permission.lvLV,
                onSiteSupportHq: tech.management.onSiteSupport.lvLV,
                progHistoryHq: tech.management.progHistory.lvLV,
                salesRecordHq: tech.management.salesRecord.lvLV,
                vehicleInfoHq: tech.management.vehicleInfo.lvLV,
                claimHq: tech.management.claim.lvLV,
                filterHq: tech.management.filter.lvLV,
                newCarlssue: tech.management.newCarIssue.lvLV,
                newCarDefinition: tech.management.newCarDefinition.lvLV,
                vehicleProductionInfo: tech.management.vehicleProductionInfo.lvLV,
                programmingHistoryInformationQuery:
                    tech.management.programmingHistoryInformationQuery.lvLV,
                ecuControllerInformationQuery: tech.management.ecuControllerInformationQuery.lvLV,
            },
        },
        components: {
            businessComponents: tech.management.businessComponents.lvLV,
        },
        statistics: statistics.inquiryStatistics.lvLV,
        systemClassifyA: statistics.systemClassifyA.lvLV,
        systemClassifyB: statistics.systemClassifyB.lvLV,
        engineerStatistics: statistics.engineerStatistics.lvLV,
        defectivePart: statistics.defectivePart.lvLV,
        replyInquiryStatistics: statistics.replyInquiryStatistics.lvLV,
        passRateStatistics: statistics.passRateStatistics.lvLV,
        timelyResponseRateStatistics: statistics.timelyResponseRateStatistics.lvLV,
        responseRateStatistics24Hour: statistics.responseRateStatistics24Hour.lvLV,
        customsClearance135Rate: statistics.customsClearance135Rate.lvLV,
        accumulatedClosureRate: statistics.accumulatedClosureRate.lvLV,
        engineerAffiliatedOrganization: statistics.engineerAffiliatedOrganization.lvLV,
        EngineerResponseRateReport: statistics.EngineerResponseRateReport.lvLV,
    },
    validation: {
        common: {
            required: 'Šis lauks ir obligāts',
            numeric: 'Jābūt veselam skaitlim',
            decimal: 'Jābūt skaitlim',
            positive_interger: 'Jābūt pozitīvam veselam skaitlim',
            up_to_digits: ({ named }: Parameters<MessageFunction>[0]) =>
                `Maksimāli ${named('number')} cipari`,
            more_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Nedrīkst pārsniegt ${named('number')} zīmes`,
            max_bytes: ({ named }: Parameters<MessageFunction>[0]) =>
                `Pārsniegts maksimālais zīmju skaits (${named('number')})`,
            less_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Jābūt vismaz ${named('number')} zīmēm`,
            must_be_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Jābūt tieši ${named('number')} zīmēm`,
            greater_than: ({ named }: Parameters<MessageFunction>[0]) =>
                `Nedrīkst būt lielāks par ${named('number')}`,
            less_than: ({ named }: Parameters<MessageFunction>[0]) =>
                `Nedrīkst būt mazāks par ${named('number')}`,
            up_to_2_decimal_places: 'Maksimāli 2 cipari aiz komata',
            retain_up: 'Maksimāli 10 cipari pirms komata, maksimāli 2 pēc komata',
            retain_ups: 'Maksimāli 11 cipari pirms komata, maksimāli 4 pēc komata',
            input_number: 'Ievadiet tikai arābu ciparus',
            only_number_a: 'Drīkst būt tikai burti vai cipari',
            translate: 'Drīkst būt tikai burti',
            positive_integer: 'Aizpildiet vismaz vienu lauku',
            at_least_one: 'Aizpildiet vismaz vienu',
        },
        tip: {
            incomplete_information: 'Informācija nav pilnīga',
        },
    },
    import: {
        template_file: 'Veidnes fails',
        browse: 'Pārlūkot',
        download_template: 'Lejupielādēt veidni',
        no_file_selected: 'Fails nav atlasīts',
        incorrect_file_type: 'Nepareizs faila tips',
        exceed: 'Pārsniegts limits',
        upload_success: 'Augšupielāde veiksmīga',
        upload_fail: 'Augšupielāde neizdevās',
        again_upload:
            'Var augšupielādēt tikai attēlus formātos jpg, png, bmp vai gif. Lūdzu, mēģiniet vēlreiz.',
        attachmentUpload: 'Pielikumu augšupielāde',
        otherAttachmentUpload: 'Citu pielikumu augšupielāde',
        supportedFormats: 'Atbalstītie formāti',
        preview: 'Priekšskatījums',
    },
    export: {
        noDataToExport: 'Nav datu eksportam',
    },
    select: {
        all: 'Visi',
    },
    checkbox: {
        select_all: 'Atlasīt visu',
    },
    dialog: {
        error_message: 'Kļūdas ziņojums',
        one_year: 'Vienu reizi var eksportēt maksimāli viena gada datus',
    },
    ymd: {
        year: 'gads',
        month: 'mēnesis',
        day: 'diena',
        week: 'nedēļa',
        january: 'Janvāris',
        february: 'Februāris',
        march: 'Marts',
        april: 'Aprīlis',
        may: 'Maijs',
        june: 'Jūnijs',
        july: 'Jūlijs',
        august: 'Augusts',
        september: 'Septembris',
        october: 'Oktobris',
        november: 'Novembris',
        december: 'Decembris',
    },
};
